var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webview-container"},[(_vm.isHtml)?_c('div',{staticClass:"content-wrapper"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.html)}})]):_c('div',[_c('iframe',{staticClass:"content-wrapper",style:(_vm.getFrameStyle),attrs:{"id":"iframe","allowfullscreen":"true","scrolling":"auto","src":_vm.url}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccabaf0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Webview.vue
// module id = null
// module chunks = 